export const MAX_AD_IMAGE_BYTES = 100 * 1024 * 1024;
export const MAX_AD_VIDEO_BYTES = 500 * 1024 * 1024;

export const AD_IMAGE_RATIO = 150 / 200;

export const AD_IMAGE_FORMATS = {
  SELL_THUMBNAIL: {
    width: 700,
    height: 700 * AD_IMAGE_RATIO,
  },
  DETAILS_THUMBNAIL: {
    width: 300,
    height: 300 * AD_IMAGE_RATIO,
  },
  DETAILS_PREVIEW: {
    width: 1200,
    height: 1200 * AD_IMAGE_RATIO,
  },
  DETAILS_FULLSCREEN: {
    width: 1600,
  },
  DETAILS_ZOOMED: {
    width: 3000,
  },
  SEARCH_PREVIEW: {
    width: 800,
    height: 800 * AD_IMAGE_RATIO,
  },
};

export interface AdImageFormat {
  width: number;
  height?: number;
}